import { desktopBreakpoint, tabletBreakpoint } from 'react-components'
import styled, { keyframes } from 'styled-components'

export const CostBar = styled.div<{ isEnquiryPopup?: boolean }>`
    display: ${({ theme }) => `${theme.style.display.flex}`};
    padding: ${({ theme }) => `${theme.spacing.xSmall} 0`};
    justify-content: ${({ theme }) => `${theme.style.justifyContent.spaceBetween}`};
    margin-bottom: ${({ theme }) => `${theme.spacing.xxxSmall}`};

    ${({ isEnquiryPopup }) =>
        !isEnquiryPopup &&
        `
        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            min-height: 4.4rem;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            min-height: 5rem;
        }
    `}
`

export const PriceGuestWrapper = styled.div`
    display: ${({ theme }) => `${theme.style.display.flex}`};
    flex-direction: ${({ theme }) => `${theme.style.flexDirection.column}`};
`

export const PricesRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: baseline;
    column-gap: ${({ theme }) => theme.spacing.xSmall};
    flex-wrap: wrap;
`

export const CurrentPrice = styled.span<{ isEnquiryPopup?: boolean; isSlasherActive?: boolean }>`
    font-family: Lato, Verdana, sans-serif;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.tfwBlack99};
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-font-smoothing: antialiased;

    ${({ isEnquiryPopup, isSlasherActive }) => {
        if (isEnquiryPopup) {
            return `
        font-size: 1.25rem;
        line-height: 1.625rem;

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            font-size: calc(1.25rem * 1.25);
            line-height: calc(1.625rem * 1.25);
        }
    `
        }

        if (isSlasherActive) {
            // Fixed sizing (no breakpoint scaling) so it aligns with the slasher price.
            return `
        font-size: 1.5rem;
        line-height: 1.5;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) and (max-width: ${tabletBreakpoint.max}px) {
            font-size: 1.25rem;
            line-height: 1;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            font-size: 1.5625rem;
            line-height: 1.875rem;
        }
    `
        }

        return `
        font-size: 1.5rem;
        line-height: 2rem;

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            font-size: calc(1.5rem * 1.3333);
            line-height: calc(2rem * 1.3333);
        }
    `
    }}
`

export const SlasherPrice = styled.span`
    position: relative;
    text-decoration: line-through;
    color: #aaaaaa;
    font-family: Lato, Verdana, sans-serif;
    font-weight: 500;
    font-size: 1.5rem;
    line-height: 1.5;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) and (max-width: ${tabletBreakpoint.max}px) {
        font-size: 1rem;
        line-height: 1;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        font-size: 1.25rem;
        line-height: 1.75rem;
    }
`

export const AvailableTag = styled.div<{ $onRequest: boolean }>`
    display: ${({ theme }) => `${theme.style.display.flex}`};
    flex-direction: ${({ theme }) => `${theme.style.flexDirection.row}`};
    padding: ${({ theme }) => `${theme.spacing.xSmall} ${theme.spacing.xxSmall}`};
    background-color: ${({ $onRequest, theme }) =>
        `${$onRequest ? theme.colors.tfwAlertMedium : theme.colors.tfwPositiveMedium}`};
    border-radius: ${({ theme }) => `${theme.typography.border.radius.xSmall}`};
    height: 1.25rem;
    justify-content: ${({ theme }) => `${theme.style.justifyContent.center}`};
    align-items: ${({ theme }) => `${theme.style.alignItems.center}`};
    width: max-content;
    flex-shrink: 0;
`

export const TickIcon = styled.img`
    height: 1rem;
    width: 1rem;
    margin-right: ${({ theme }) => `${theme.spacing.xxxSmall}`};
`

// Keyframes for the spinner animation
const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`

// Styled component for the spinner
interface SpinnerProps {
    $size: number
    $color: string
}

export const Spinner = styled.div<SpinnerProps>`
    border: ${({ $size }) => $size / 10}px solid #f3f3f3; /* Light gray border */
    border-top: ${({ $size }) => $size / 10}px solid ${({ $color }) => $color}; /* Customizable color */
    border-radius: 50%;
    width: ${({ $size }) => $size}px;
    height: ${({ $size }) => $size}px;
    animation: ${spin} 1s linear infinite;
`
